"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgTransferNFT = void 0;
var ow_1 = __importDefault(require("ow"));
var ow_types_1 = require("../ow.types");
var address_1 = require("../../../utils/address");
var typeurl_1 = require("../../common/constants/typeurl");
exports.msgTransferNFT = function (config) {
    return (function () {
        function MsgTransferNFT(options) {
            ow_1.default(options, 'options', ow_types_1.owMsgTransferNFTOptions);
            this.id = options.id;
            this.sender = options.sender;
            this.denomId = options.denomId;
            this.recipient = options.recipient;
            this.validateAddresses();
        }
        MsgTransferNFT.prototype.toRawMsg = function () {
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.nft.MsgTransferNFT,
                value: {
                    id: this.id,
                    sender: this.sender,
                    denomId: this.denomId,
                    recipient: this.recipient,
                },
            };
        };
        MsgTransferNFT.prototype.toRawAminoMsg = function () {
            return {
                type: 'chainmain/nft/MsgTransferNFT',
                value: {
                    id: this.id,
                    sender: this.sender,
                    denom_id: this.denomId,
                    recipient: this.recipient,
                },
            };
        };
        MsgTransferNFT.prototype.validateAddresses = function () {
            if (!address_1.validateAddress({
                address: this.sender,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `sender` does not match network selected');
            }
            if (!address_1.validateAddress({
                address: this.recipient,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `recipient` does not match network selected');
            }
        };
        return MsgTransferNFT;
    }());
};
//# sourceMappingURL=MsgTransferNFT.js.map